declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ActorMedicalFitnessRequest, ActorMedicalFitnessInfoController } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';
import { HCPService } from '../../../../../services/hcp.service';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';

@Component({
  selector: 'ngbmedicalfitnessinfo',
  templateUrl: './medicalfitnessinfo.modal.html',
  styleUrls: ['./medicalfitnessinfo.modal.scss']
})

export class NgbMedicalFitnessinfoModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() ActorCode: number;
  @Input() CurrentActorMedicalFitnessInfoControllerByCode: ActorMedicalFitnessInfoController;

  CurrentActorMedicalFitnessRequest: ActorMedicalFitnessRequest;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService) { }
  ngOnInit() {

    this.CurrentActorMedicalFitnessRequest = new ActorMedicalFitnessRequest();
    this.CurrentActorMedicalFitnessRequest.ActorCode = this.ActorCode;
    this.CurrentActorMedicalFitnessRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }
  onCredentialTypeByGroup(event: any) {

    if (event != null) {

      this.CurrentActorMedicalFitnessRequest.CredentialType = event;


    }

  }



  onSubmit() {
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorMedicalFitnessRequest.ConditionalOperator = 1;
    this.hcpservice.SaveActorMedicalFitnessInfo(this.CurrentActorMedicalFitnessRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            alertFunctions.AlertParam('Saved Successfully.....!');
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
      }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  //
  ///////////////////DetailGrid
  //Grid Vars start
  disREADONLY: boolean = false;

  ddbops: DBOperation;
  dcolumns: any[] = [
    {
      display: 'Fitness Type',
      variable: 'CredentialType',
      filter: 'text',
    },
    {
      display: 'Fitness Number',
      variable: 'CredentialNumber',
      filter: 'text'
    },
    {
      display: 'ValidFrom',
      variable: 'ValidFrom',
      filter: 'date'
    }
    ,
    {
      display: 'ValidTo',
      variable: 'ValidTo',
      filter: 'date'
    }
    ,
    {
      display: 'IssuingAuthority',
      variable: 'IssuingAuthorityLongValue',
      filter: 'text'
    }
    ,
    {
      display: 'Remarks',
      variable: 'Remarks',
      filter: 'text'
    }
    ,
    {
      display: 'AdditionalDetail',
      variable: 'AdditionalDetail',
      filter: 'text'
    }


  ];




}
